import { ADD_NEW_LESSONPLAN, ADD_NEW_LESSONPLAN_FAILED, ADD_NEW_LESSONPLAN_SUCCESS, GET_ADMIN_LESSONPLAN, GET_ADMIN_LESSONPLAN_FAILED, GET_ADMIN_LESSONPLAN_SUCCESS, GET_STUD_LESSONPLAN, GET_STUD_LESSONPLAN_FAILED, GET_STUD_LESSONPLAN_SUCCESS, GET_TEACHER_LESSONPLAN, GET_TEACHER_LESSONPLAN_FAILED, GET_TEACHER_LESSONPLAN_SUCCESS, UPDATE_LESSONPLAN, UPDATE_LESSONPLAN_FAILED, UPDATE_LESSONPLAN_SUCCESS } from "./Constants";

export const getTeacherLessonPlan = () => ({
    type: GET_TEACHER_LESSONPLAN
})

export const getTeacherLessonPlanSuccess = (payload) => ({
    type: GET_TEACHER_LESSONPLAN_SUCCESS,
    payload
})

export const getTeacherLessonPlanFailed = (payload) => ({
    type: GET_TEACHER_LESSONPLAN_FAILED,
    payload
})

export const addNewLessonPlan = (payload) =>({
    type: ADD_NEW_LESSONPLAN,
    payload
})

export const addNewLessonPlanSuccess = (payload) =>({
    type: ADD_NEW_LESSONPLAN_SUCCESS,
    payload
})

export const addNewLessonPlanFailed = (payload) =>({
    type: ADD_NEW_LESSONPLAN_FAILED,
    payload
})


export const updateLessonPlan = (payload) =>({
    type: UPDATE_LESSONPLAN,
    payload
})

export const updateLessonPlanSuccess = (payload) =>({
    type: UPDATE_LESSONPLAN_SUCCESS,
    payload
})

export const updateLessonPlanFailed = (payload) =>({
    type: UPDATE_LESSONPLAN_FAILED,
    payload
})

export const getStudLessonPlan = (payload) =>({
    type: GET_STUD_LESSONPLAN,
    payload
})

export const getStudLessonPlanSuccess = (payload) =>({
    type: GET_STUD_LESSONPLAN_SUCCESS,
    payload
})

export const getStudLessonPlanFailed = (payload) =>({
    type: GET_STUD_LESSONPLAN_FAILED,
    payload
})

export const getAdminLesssonPlan = () =>({
    type: GET_ADMIN_LESSONPLAN
})

export const getAdminLesssonPlanSuccess = (payload) =>({
    type: GET_ADMIN_LESSONPLAN_SUCCESS,
    payload
})

export const getAdminLesssonPlanFailed = (payload) =>({
    type: GET_ADMIN_LESSONPLAN_FAILED,
    payload
})